import {api} from "../core/api";
import {handleHttp, IProps} from "../core/handleHttp";

export const alterarSenha = async (novaSenha: string, confirmarSenha: string) => {
    let req: IProps = {
        api: api,
        type: "put",
        url: "/v1/usuario/senha",
        body: {novaSenha, confirmarSenha}
    }
    return await handleHttp(req)
}
